module.exports = {"140729100":"翠峰镇","140729101":"静升镇","140729102":"两渡镇","140729103":"夏门镇","140729104":"南关镇","140729105":"段纯镇","140729202":"王禹乡","140729203":"坛镇乡","140729204":"梁家焉乡","140729205":"交口乡","140729403":"灵石县城区社会事务服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140729.json
// module id = 419
// module chunks = 0